import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';

const SignUpPage: React.FC = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    password: '',
    confirmPassword: '',
    meNumber: '',
    csid: ''
  });

  const [submitted, setSubmitted] = useState(false);
  const [showMEHelp, setShowMEHelp] = useState(false);
  const [showCSIDHelp, setShowCSIDHelp] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    if (formData.password !== formData.confirmPassword) {
      alert('Passwords do not match!');
      return;
    }

    // Handle sign up logic here
    console.log('Sign up submitted:', formData);
    setSubmitted(true);
  };

  return (
    <div className="sign-up-page">
      <section className="auth-content">
        <div className="container">
          <div className="auth-card" style={{ maxWidth: '600px' }}>
            <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
              <h1 style={{ fontSize: '2.5rem', color: '#d32f2f', marginBottom: '0.5rem' }}>Create Your Account</h1>
              <p style={{ color: '#666', fontSize: '1.1rem' }}>
                Join Alert1 and get access to 24/7 support and account management
              </p>
            </div>

            {submitted ? (
              <div className="success-message">
                <div className="success-icon">✓</div>
                <h2>Welcome to Alert1!</h2>
                <p>
                  Your account has been created successfully. We've sent a confirmation 
                  email to <strong>{formData.email}</strong>.
                </p>
                <p className="help-text">
                  Please check your email and verify your account to get started.
                </p>
                <Link to="/my-account" className="btn btn-primary">
                  Sign In to Your Account
                </Link>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="auth-form">
                <div className="form-row" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                  <div className="form-group">
                    <label htmlFor="firstName">First Name *</label>
                    <input
                      type="text"
                      id="firstName"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="lastName">Last Name *</label>
                    <input
                      type="text"
                      id="lastName"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email Address *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="your.email@example.com"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="phone">Phone Number *</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    placeholder="(555) 123-4567"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="meNumber">ME Number:</label>
                  <input
                    type="text"
                    id="meNumber"
                    name="meNumber"
                    value={formData.meNumber}
                    onChange={handleChange}
                    placeholder="Enter your ME number"
                  />
                  <button 
                    type="button"
                    className="help-link-button"
                    onClick={() => setShowMEHelp(true)}
                  >
                    How do I find this information?
                  </button>
                </div>

                <div className="form-group">
                  <label htmlFor="csid">CSID:</label>
                  <input
                    type="text"
                    id="csid"
                    name="csid"
                    value={formData.csid}
                    onChange={handleChange}
                    placeholder="Enter your CSID"
                  />
                  <button 
                    type="button"
                    className="help-link-button"
                    onClick={() => setShowCSIDHelp(true)}
                  >
                    How do I find this information?
                  </button>
                </div>

                <div className="form-group">
                  <label htmlFor="password">Password *</label>
                  <input
                    type="password"
                    id="password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    required
                    minLength={8}
                    placeholder="At least 8 characters"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="confirmPassword">Confirm Password *</label>
                  <input
                    type="password"
                    id="confirmPassword"
                    name="confirmPassword"
                    value={formData.confirmPassword}
                    onChange={handleChange}
                    required
                    placeholder="Re-enter your password"
                  />
                </div>

                <button type="submit" className="btn btn-primary btn-large">
                  Create Account
                </button>

                <div className="auth-links">
                  <Link to="/my-account">Already have an account? Sign in</Link>
                </div>

                <p className="terms-notice" style={{ fontSize: '0.85rem', color: '#999', textAlign: 'center', marginTop: '1rem' }}>
                  By creating an account, you agree to our <Link to="/terms">Terms of Service</Link> and <Link to="/privacy">Privacy Policy</Link>.
                </p>
              </form>
            )}

            <div className="auth-help">
              <h4>Questions About Creating an Account?</h4>
              <p>
                Call us at <strong>1-877-579-9862</strong> and we'll be happy to assist you.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ME Number Help Modal */}
      {showMEHelp && (
        <div className="modal-overlay" onClick={() => setShowMEHelp(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setShowMEHelp(false)}>×</button>
            <div className="modal-body">
              <p>
                You can find your ME number on the bottom portion of your invoice.
              </p>
              <p>
                For assistance, contact member care at{' '}
                <strong>1-800-693-5433</strong> and choose option 2.
              </p>
            </div>
          </div>
        </div>
      )}

      {/* CSID Help Modal */}
      {showCSIDHelp && (
        <div className="modal-overlay" onClick={() => setShowCSIDHelp(false)}>
          <div className="modal-content modal-large" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setShowCSIDHelp(false)}>×</button>
            <div className="modal-body">
              <h3 style={{ color: '#2b5ea6', marginTop: 0 }}>Location of Your CSID</h3>
              <div className="csid-info">
                <p>Six digit code beginning with the letter "J", "K", "C", "RL", "WP", or "V" on the back of the <strong>home base unit</strong> OR...</p>
                <p>Nine digit code beginning with "SEC" on the back of <strong>Kelsi</strong> OR...</p>
                <p>Nine digit code beginning with letters "NL" on the bottom of the <strong>PAX charging base</strong>.</p>
              </div>
              <p style={{ marginTop: '1rem' }}>
                For assistance, contact customer care at{' '}
                <strong>1-800-693-5433</strong> and choose option 2.
              </p>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default SignUpPage;

